import React from "react";
import { BrowserRouter } from "react-router-dom";
import RootNavigation from "./navigation/RootNavigation";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "./utils/theme";
import { AuthProvider } from "./context/AuthContext";
import NetworkStatus from "./components/NetworkStatus";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <NetworkStatus />
          <RootNavigation />
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
